"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubstanceSpecificationName = void 0;
/**
 * The detailed description of a substance, typically at a level beyond what is used for prescribing.
 */
var SubstanceSpecificationName = /** @class */ (function () {
    function SubstanceSpecificationName() {
    }
    return SubstanceSpecificationName;
}());
exports.SubstanceSpecificationName = SubstanceSpecificationName;
